import ReactTooltip from "react-tooltip"
import { useTranslation } from "react-i18next"

import { UploadedDocument } from "models"

import { EyeSeeIcon, Button, variants, sizes } from "components/Elements"

type LinkToRemoteFileProps = {
	file: UploadedDocument
	label?: string
	className?: string
	variant?: keyof typeof variants
	size?: keyof typeof sizes
	disabled?: boolean
}

export const LinkToRemoteFile: React.FC<LinkToRemoteFileProps> = ({
	file,
	label,
	className = "",
	variant,
	size,
	disabled,
}) => {
	const { t } = useTranslation()
	return (
		<>
			<Button
				variant={variant}
				size={size}
				link={file?.document_data?.url}
				className={`c-input-file__button ${className}`}
				disabled={disabled || !file?.document_data?.url}
				additionalProps={{
					"aria-label": label ?? t("file_show_remote_file", { ns: "form" }),
					...(label ? {} : { "data-tip": t("file_show_remote_file", { ns: "form" }) }),
				}}
			>
				<EyeSeeIcon size="20" />
				{label && <span className="ml-3">{label}</span>}
			</Button>
			{!label && <ReactTooltip backgroundColor={"var(--primaryColor)"} />}
		</>
	)
}
